/* eslint-disable no-console */
export const error = console.error
export const log = console.log
export const debug = console.debug
